// extracted by mini-css-extract-plugin
export default {"container":"image-upload_container__DRH3X","content":"image-upload_content__846IK","close":"image-upload_close__b3bjn","hasFile":"image-upload_hasFile__UtG-V"};